export default {"src":"/_next/static/media/frax.0f0670da.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};